/**
 * Author(s) : Gurudharshan
 * Purpose : This is a generic page container component is used to contain the page component.
 */

import styles from './PageContainer.module.scss'
import PropTypes from 'prop-types';

 function PageContainer(props) {
   return (
     (
        <div className={styles.pageContainerWrapper}>
          {props.children}
        </div>
     )
   );
 }
 
 export default PageContainer;
 
//Proptypes for pagecontainer component
PageContainer.propTypes = {
  children: PropTypes.object,
  isHamburgerOpen: PropTypes.bool
};